import { ActionCardDescription } from '@components/action-card';
import { Card } from '@components/card';
import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { ActionBasic } from 'ui/journey-builder/node-types/common';

import { ActionIcon, getActionLabel, isStructuralAction } from '../action-config';

export const BranchActionCard = ({
  action,
  isDeleteAction = false,
}: {
  action: ActionBasic;
  isDeleteAction?: boolean;
}) => {
  return (
    <Card space={4} style={{ width: '100%' }} variant={isDeleteAction ? 'red' : 'default'}>
      <Stack space={2} orientation="horizontal" align="center" justify="space-between">
        <Stack space={2} orientation="horizontal" align="center">
          <ActionIcon action={action.action} />
          <Stack space={1}>
            <Text
              font="semibold14"
              color="textPrimary"
              text={getActionLabel(action.action)}
              ellipsis
            />
            {!isStructuralAction(action.action) && (
              <ActionCardDescription text={action.description} />
            )}
          </Stack>
        </Stack>
        {!isDeleteAction && <IconFormIndicatorWarning />}
      </Stack>
    </Card>
  );
};
